import React from 'react';
import { assetBaseUrl } from '../../../config';

export const CHMapIcon = () => (
  <svg
    width="100"
    height="101"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50 23.874C35.5025 23.874 23.75 35.6265 23.75 50.124C23.75 64.6215 35.5025 76.374 50 76.374C64.4975 76.374 76.25 64.6215 76.25 50.124C76.25 35.6265 64.4975 23.874 50 23.874ZM20 50.124C20 33.5555 33.4315 20.124 50 20.124C66.5685 20.124 80 33.5555 80 50.124C80 66.6926 66.5685 80.124 50 80.124C33.4315 80.124 20 66.6926 20 50.124Z"
      fill="white"
    />
    <path
      d="M50 75.6743C52.6046 75.6743 54.716 73.5629 54.716 70.9583C54.716 68.3538 52.6046 66.2423 50 66.2423C47.3954 66.2423 45.284 68.3538 45.284 70.9583C45.284 73.5629 47.3954 75.6743 50 75.6743Z"
      fill="white"
    />
    <path
      d="M40.1366 72.7833C42.7412 72.7833 44.8526 70.6719 44.8526 68.0673C44.8526 65.4628 42.7412 63.3513 40.1366 63.3513C37.532 63.3513 35.4206 65.4628 35.4206 68.0673C35.4206 70.6719 37.532 72.7833 40.1366 72.7833Z"
      fill="white"
    />
    <path
      d="M59.8632 72.7833C62.4678 72.7833 64.5792 70.6719 64.5792 68.0673C64.5792 65.4628 62.4678 63.3513 59.8632 63.3513C57.2587 63.3513 55.1472 65.4628 55.1472 68.0673C55.1472 70.6719 57.2587 72.7833 59.8632 72.7833Z"
      fill="white"
    />
  </svg>
);

export const CHCloseIcon = ({ color = 'white' }: { color?: string }) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.2858 30.9435L30.6579 72.5715L27.7144 69.6279L69.3423 28L72.2858 30.9435Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.7144 30.9435L69.3423 72.5715L72.2859 69.6279L30.6579 28L27.7144 30.9435Z"
      fill={color}
    />
  </svg>
);

export const CHArrowIcon = ({
  direction = 'down'
}: {
  direction?: 'up' | 'down' | 'left' | 'right';
}) => {
  const getTransformByDirection = () => {
    switch (direction) {
      case 'up':
        return 'rotate(180deg)';
      case 'down':
        return 'rotate(0deg)';
      case 'left':
        return 'rotate(90deg)';
      case 'right':
        return 'rotate(-90deg)';
      default:
        return 'rotate(0deg)';
    }
  };

  return (
    <svg
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: getTransformByDirection() }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4167 43.2596L49.9739 59.8169L50 59.7908L50.0261 59.8169L66.5834 43.2596L63.755 40.4312L50 54.1861L36.2451 40.4312L33.4167 43.2596Z"
        fill="white"
      />
    </svg>
  );
};

export const CHCinematicIcon = ({ color }: { color: string }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5667 22.6898C18.3104 22.6898 22.9667 18.0336 22.9667 12.2898C22.9667 6.54603 18.3104 1.8898 12.5667 1.8898C6.82289 1.8898 2.16665 6.54603 2.16665 12.2898C2.16665 18.0336 6.82289 22.6898 12.5667 22.6898ZM12.5667 24.2898C19.1941 24.2898 24.5667 18.9172 24.5667 12.2898C24.5667 5.66238 19.1941 0.289795 12.5667 0.289795C5.93923 0.289795 0.56665 5.66238 0.56665 12.2898C0.56665 18.9172 5.93923 24.2898 12.5667 24.2898Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5666 7.8641C13.2436 7.8641 13.7923 7.31534 13.7923 6.63842C13.7923 5.9615 13.2436 5.41274 12.5666 5.41274C11.8897 5.41274 11.341 5.9615 11.341 6.63842C11.341 7.31534 11.8897 7.8641 12.5666 7.8641ZM12.5666 9.4641C14.1272 9.4641 15.3923 8.199 15.3923 6.63842C15.3923 5.07784 14.1272 3.81274 12.5666 3.81274C11.0061 3.81274 9.74097 5.07784 9.74097 6.63842C9.74097 8.199 11.0061 9.4641 12.5666 9.4641Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.218 13.5155C18.8949 13.5155 19.4437 12.9667 19.4437 12.2898C19.4437 11.6129 18.8949 11.0641 18.218 11.0641C17.5411 11.0641 16.9923 11.6129 16.9923 12.2898C16.9923 12.9667 17.5411 13.5155 18.218 13.5155ZM18.218 15.1155C19.7786 15.1155 21.0437 13.8504 21.0437 12.2898C21.0437 10.7292 19.7786 9.46411 18.218 9.46411C16.6574 9.46411 15.3923 10.7292 15.3923 12.2898C15.3923 13.8504 16.6574 15.1155 18.218 15.1155Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5666 19.1668C13.2436 19.1668 13.7923 18.6181 13.7923 17.9412C13.7923 17.2642 13.2436 16.7155 12.5666 16.7155C11.8897 16.7155 11.341 17.2642 11.341 17.9412C11.341 18.6181 11.8897 19.1668 12.5666 19.1668ZM12.5666 20.7668C14.1272 20.7668 15.3923 19.5017 15.3923 17.9412C15.3923 16.3806 14.1272 15.1155 12.5666 15.1155C11.0061 15.1155 9.74097 16.3806 9.74097 17.9412C9.74097 19.5017 11.0061 20.7668 12.5666 20.7668Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91528 13.5155C7.5922 13.5155 8.14095 12.9667 8.14095 12.2898C8.14095 11.6129 7.5922 11.0641 6.91528 11.0641C6.23835 11.0641 5.6896 11.6129 5.6896 12.2898C5.6896 12.9667 6.23835 13.5155 6.91528 13.5155ZM6.91528 15.1155C8.47585 15.1155 9.74095 13.8504 9.74095 12.2898C9.74095 10.7292 8.47585 9.46411 6.91528 9.46411C5.3547 9.46411 4.0896 10.7292 4.0896 12.2898C4.0896 13.8504 5.3547 15.1155 6.91528 15.1155Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5667 24.2897H13.0959V22.6897H24.5667V24.2897Z"
      fill={color}
    />
  </svg>
);

export const CHLanguageIcon = ({ color }: { color: string }) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7667 18.3766V21.7779C11.0195 21.4859 10.2034 20.7711 9.4623 19.4647C9.27213 19.1295 9.09402 18.7658 8.93035 18.3766H11.7667ZM9.5217 22.1706C7.37153 21.5061 5.52227 20.1564 4.22902 18.3766H7.21243C7.78825 19.9573 8.58321 21.2664 9.5217 22.1706ZM15.6116 22.1706C17.7618 21.5061 19.611 20.1564 20.9043 18.3766H17.9209C17.3451 19.9573 16.5501 21.2664 15.6116 22.1706ZM21.8588 16.7766C22.3952 15.6578 22.7356 14.4271 22.8354 13.129H18.909C18.8575 14.4171 18.6825 15.6452 18.4047 16.7766H21.8588ZM24.4659 12.3064V11.529H24.4395C24.0455 5.59476 19.301 0.850341 13.3667 0.456399V0.429932H12.5667H11.7667V0.456397C5.83231 0.850326 1.08778 5.59475 0.693828 11.529H0.667358V13.129H0.693829C1.10533 19.3277 6.26371 24.2281 12.5667 24.2281C18.8696 24.2281 24.028 19.3277 24.4395 13.129H24.4659V12.3516C24.466 12.3441 24.466 12.3365 24.466 12.329C24.466 12.3215 24.466 12.3139 24.4659 12.3064ZM2.29797 13.129C2.3977 14.4271 2.73807 15.6578 3.27456 16.7766H6.72862C6.45085 15.6452 6.27582 14.4171 6.22429 13.129H2.29797ZM2.29797 11.529H6.22429C6.27582 10.2409 6.45085 9.01285 6.72862 7.88146H3.27456C2.73807 9.00025 2.3977 10.2309 2.29797 11.529ZM4.22902 6.28146H7.21243C7.78825 4.70069 8.58321 3.39159 9.5217 2.48746C7.37153 3.15193 5.52227 4.50164 4.22902 6.28146ZM15.6116 2.48745C16.5501 3.39159 17.3451 4.70069 17.9209 6.28146H20.9043C19.6111 4.50163 17.7618 3.15193 15.6116 2.48745ZM21.8588 7.88146C22.3952 9.00025 22.7356 10.2309 22.8354 11.529H18.909C18.8575 10.2409 18.6825 9.01285 18.4047 7.88146H21.8588ZM11.7667 16.7766H8.38157C8.07988 15.6763 7.88292 14.4458 7.82566 13.129H11.7667V16.7766ZM11.7667 11.529H7.82566C7.88292 10.2122 8.07988 8.98171 8.38157 7.88146H11.7667V11.529ZM11.7667 6.28146H8.93035C9.09402 5.89223 9.27213 5.52851 9.4623 5.1933C10.2034 3.88696 11.0195 3.17209 11.7667 2.88009V6.28146ZM13.3667 6.28146V2.8801C14.1139 3.17212 14.9299 3.88698 15.671 5.1933C15.8612 5.52851 16.0393 5.89223 16.203 6.28146H13.3667ZM13.3667 7.88146H16.7517C17.0534 8.98171 17.2504 10.2122 17.3077 11.529H13.3667V7.88146ZM13.3667 13.129H17.3077C17.2504 14.4458 17.0534 15.6763 16.7517 16.7766H13.3667V13.129ZM13.3667 18.3766H16.203C16.0393 18.7658 15.8612 19.1295 15.671 19.4647C14.9299 20.771 14.1139 21.4859 13.3667 21.7779V18.3766Z"
      fill={color}
    />
  </svg>
);

export const CHNavArrowIcon = ({
  direction,
  animated
}: {
  direction: 'up' | 'left' | 'down' | 'right';
  animated?: boolean;
}) => {
  const getTransformByDirection = () => {
    switch (direction) {
      case 'up':
        return 'rotate(180deg)';
      case 'down':
        return 'rotate(0deg)';
      case 'left':
        return 'rotate(90deg)';
      case 'right':
        return 'rotate(-90deg)';
      default:
        return 'rotate(0deg)';
    }
  };

  const getMoveStart = () => {
    switch (direction) {
      case 'up':
      case 'down':
        return 'translateY(0)';
      default:
        return 'translateX(0)';
    }
  };

  const getMoveEnd = () => {
    switch (direction) {
      case 'up':
        return 'translateY(-90%)';
      case 'down':
        return 'translateY(90%)';
      case 'left':
        return 'translateX(-90%)';
      default:
        return 'translateX(90%)';
    }
  };

  return (
    <svg
      width="24"
      height="15"
      viewBox="0 0 24 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={animated ? 'moving' : ''}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.477783 2.73058L11.9818 14.2346L12 14.2165L12.0181 14.2346L23.5221 2.73058L21.5569 0.765381L12 10.3224L2.44298 0.765381L0.477783 2.73058Z"
        fill="currentColor"
      />
      <style jsx>{`
        svg {
          transform: ${getMoveStart()} ${getTransformByDirection()};
        }
        .moving {
          animation: arrow-animation-${direction} 2s ease-in-out infinite;
        }
        @keyframes arrow-animation-${direction} {
          0%,
          10% {
            opacity: 0;
            transform: ${getMoveStart()} ${getTransformByDirection()};
          }
          30% {
            opacity: 1;
            transform: ${getMoveStart()} ${getTransformByDirection()};
          }
          70% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform: ${getMoveEnd()} ${getTransformByDirection()};
          }
        }
      `}</style>
    </svg>
  );
};

export const CHMusicIcon = ({ paused }: { paused?: boolean }) =>
  paused ? (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 54.3033C52.3767 54.3033 54.3033 52.3767 54.3033 50C54.3033 47.6233 52.3767 45.6967 50 45.6967C47.6233 45.6967 45.6967 47.6233 45.6967 50C45.6967 52.3767 47.6233 54.3033 50 54.3033ZM50 58.3033C54.5858 58.3033 58.3033 54.5858 58.3033 50C58.3033 45.4142 54.5858 41.6967 50 41.6967C45.4142 41.6967 41.6967 45.4142 41.6967 50C41.6967 54.5858 45.4142 58.3033 50 58.3033Z"
        fill="white"
      />
      <circle cx="57.4581" cy="73.6299" r="9.86152" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.3277 19.8338H76.0231V23.8338H67.3277V74.2138H63.3277V19.8338Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.3033 20.3023C55.6616 19.5653 52.8768 19.1712 50 19.1712C32.9737 19.1712 19.1712 32.9737 19.1712 50C19.1712 64.9146 29.7623 77.3554 43.8338 80.212C43.2128 78.9187 42.8269 77.4911 42.7315 75.9846C31.3641 72.8116 23.0248 62.3797 23.0248 50C23.0248 35.102 35.102 23.0248 50 23.0248C52.8971 23.0248 55.6876 23.4815 58.3033 24.3269V20.3023Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.3867 82.3869L80.1145 19.1458L77.0898 16.5283L22.362 79.7694L25.3867 82.3869Z"
        fill="white"
      />
    </svg>
  ) : (
    <img src={`${assetBaseUrl}/chopard/chsps/music-on.gif`} alt="" />
  );

export const ScanIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.501 12.5V12.5H14.501V12.5H20.001V14.5H14.501V20H12.501V14.5V12.5ZM12.501 30V35.5V37.5H14.501H20.001V35.5H14.501V30H12.501ZM37.501 35.5V30H35.501V35.5H30.001V37.5H35.501H37.501V35.5ZM37.501 12.5L35.501 12.5L30.001 12.5V14.5H35.501V20H37.501V14.5V12.5ZM37.501 26.1459H12.501V24.1459H37.501V26.1459Z"
      fill="black"
    />
  </svg>
);

export const ARIcon = () => (
  <svg
    width="75"
    height="45"
    viewBox="0 0 166 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.5391 49.9249V19.2746H48.8503V49.9249H46.5391Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48.2751 48.9256L75.8219 64.9239L74.6612 66.9226L47.1144 50.9242L48.2751 48.9256Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.1041 48.9256L19.5573 64.9239L20.7181 66.9226L48.2649 50.9242L47.1041 48.9256Z"
      fill="black"
      fillOpacity="0.2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.6894 17.7091L76.3969 33.6719V66.0914L47.6894 82.5488L18.9819 66.0914V33.6719L47.6894 17.7091ZM47.6894 20.3536L22.5433 34.3361L47.6894 47.8983L72.8355 34.3361L47.6894 20.3536ZM74.0857 36.2878L48.8451 49.9009V79.2222L74.0857 64.7522V36.2878ZM46.5338 79.2222V49.9009L21.2932 36.2878V64.7522L46.5338 79.2222Z"
      fill="black"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.6844 47.1605L51.6019 45.0477L53.3526 48.2938L49.5285 50.3562V54.8232H45.8404V50.3562L42.0163 48.2938L43.767 45.0477L47.6844 47.1605Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.4495 29.0247L77.0855 33.2707V41.924H73.3974V37.445L69.4173 39.5915L67.6666 36.3455L71.4025 34.3306L67.6572 32.248L69.4495 29.0247Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M69.4495 71.0264L77.0855 66.7804V58.1271H73.3974V62.6062L69.4173 60.4596L67.6666 63.7057L71.4025 65.7205L67.6572 67.8031L69.4495 71.0264Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9297 29.0247L18.2937 33.2707V41.924H21.9818V37.445L25.9619 39.5915L27.7126 36.3455L23.9767 34.3306L27.722 32.248L25.9297 29.0247Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9297 71.0264L18.2937 66.7804V58.1271H21.9818V62.6062L25.9619 60.4596L27.7126 63.7057L23.9767 65.7205L27.722 67.8031L25.9297 71.0264Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.5337 73.9145V78.034L53.071 76.0061L54.9052 79.2057L47.6897 83.3423L40.4741 79.2057L42.3084 76.0061L45.8456 78.034V73.9145H49.5337Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.5337 26.3335V22.2141L53.071 24.2419L54.9052 21.0423L47.6897 16.9058L40.4741 21.0423L42.3084 24.2419L45.8456 22.2141V26.3335H49.5337Z"
      fill="black"
    />
    <path
      d="M106.44 53.2175H116.462L111.43 43.1328L106.44 53.2175ZM99.0977 62.0029L110.255 39.2351H112.606L123.887 62.0029H120.814L117.72 55.8779H105.14L102.129 62.0029H99.0977Z"
      fill="black"
    />
    <path
      d="M130.053 49.3816H140.096C141.526 49.3816 142.606 49.0654 143.334 48.433C144.077 47.8005 144.448 46.8725 144.448 45.6488C144.448 44.4527 144.077 43.5247 143.334 42.8647C142.606 42.191 141.574 41.8542 140.241 41.8542H130.053V49.3816ZM127.228 62.0029V39.2351H140.282C142.509 39.2351 144.255 39.7988 145.52 40.9262C146.785 42.0398 147.418 43.5865 147.418 45.5664C147.418 47.2162 146.923 48.6323 145.933 49.8147C144.943 50.9833 143.637 51.712 142.014 52.0008L147.706 62.0029H144.572L138.88 52.042H130.053V62.0029H127.228Z"
      fill="black"
    />
  </svg>
);

export const FullScreenIcon = () => {
  return (
    <svg
      width="100"
      height="101"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 29.124V40.124H29V29.124H40V25.124L29 25.124H25V29.124ZM25 71.124V60.124H29V71.124H40V75.124H29H25V71.124ZM75 60.124V71.124V75.124H71H60V71.124H71V60.124H75ZM71 25.124L75 25.124V29.124V40.124H71V29.124H60V25.124L71 25.124Z"
        fill="white"
      />
    </svg>
  );
};
